import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/GuestConstants';
import NotificationActions from '../actions/NotificationActions';

export default {

    loadGuestAvatar:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_GUEST_AVATAR, formData)
            .then(response => {
                if(response.Result) {
                    return response.Data ? `data:image/png;base64,${response.Data}` : null;
                } else if(!response.Result) {
                    NotificationActions.error(`Failed to load guest avatar: ${response.Message}`);
                    return null;
                }
            });
    },

    loadFullGuest:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_FULL_GUEST, formData);
    },

    // createNewGuest:(formData) => {
    //     return AjaxPromises.POST(EndPoints.CREATE_NEW_GUEST, formData);
    // },

    editGuestProfile:(formData) => {
        return AjaxPromises.POST(EndPoints.EDIT_GUEST_PROFILE, formData);
    },

    viewPatientNotes:(formData) => {
        return AjaxPromises.POST(EndPoints.VIEW_PATIENT_NOTES, formData);
    },

    loadSecondaryId:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_SECONDARY_ID, formData);
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/api/GuestApi.jsx